/**
 * Lumio nudge signals: the canonical, language-independent page facts sent with
 * `POST /assistant/context-event` (the backend's `PageSignals`). Keys and bands
 * are stable identifiers; only `label` is display text, echoed back in the nudge.
 */
export type LumioBand = 'poor' | 'sustainable' | 'optimal';

export interface LumioFeatureSignal {
  /** Catalog item id. */
  key: string;
  /** Feature name as the owner sees it. */
  label: string;
  /** Market Score points activating it would add, as shown on its card. */
  market_uplift: number;
}

export interface LumioSignals {
  area_scores: Record<string, { score: number; band: LumioBand; calibrating: boolean }>;
  inactive_features: LumioFeatureSignal[];
  setup_incomplete: boolean;
}

// The inactive-feature cards are derived inside the Product page (catalog ladder,
// pending invoices, region), so the page publishes what it renders and the layout's
// nudge hook reads it at send time. Empty on every other page.
let inactiveFeatures: LumioFeatureSignal[] = [];

export const publishLumioInactiveFeatures = (features: LumioFeatureSignal[]): void => {
  inactiveFeatures = features;
};

export const lumioInactiveFeatures = (): LumioFeatureSignal[] => inactiveFeatures;
